import { iconsImgs } from "../../utils/icons";
import _ from "./noPartyBanner.module.scss";
const NoPartyBanner = () => {
  return (
    <div className={_._noPartyBannerContainer}>
      <h1 className={_._header}>
        You have no upcoming parties, <br /> let's find one !
      </h1>
      {/* <div className={_._buttonContainer}>
        <a href="">
          <img src={iconsImgs.GoOut} alt="GoOutButton" />
        </a>
      </div> */}
    </div>
  );
};

export default NoPartyBanner;
